module.exports = __webpack_public_path__ + "img/1.830491e2.svg";